var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar is-fixed-top",class:_vm.background_colour,attrs:{"role":"navigation","aria-label":"main navigation"}},[_c('div',{staticClass:"navbar-brand"},[_c('a',{staticClass:"navbar-item",attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.navbar_logo}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }